/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DeleteFacilityCustomTag200ResponseData
 */
export interface DeleteFacilityCustomTag200ResponseData {
    /**
     *
     * @type {string}
     * @memberof DeleteFacilityCustomTag200ResponseData
     */
    id: string;
}

/**
 * Check if a given object implements the DeleteFacilityCustomTag200ResponseData interface.
 */
export function instanceOfDeleteFacilityCustomTag200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function DeleteFacilityCustomTag200ResponseDataFromJSON(json: any): DeleteFacilityCustomTag200ResponseData {
    return DeleteFacilityCustomTag200ResponseDataFromJSONTyped(json, false);
}

export function DeleteFacilityCustomTag200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityCustomTag200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
    };
}

export function DeleteFacilityCustomTag200ResponseDataToJSON(value?: DeleteFacilityCustomTag200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
    };
}
